import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import PageItem from '~/components/Layout/Builders/PageItem';
import type { PageBuilderBlockType } from '~/types/AppData/PageBuilder/PageBuilderBlockType';

type PageBuilderType = {
  items: PageBuilderBlockType[];
};

export default component$<PageBuilderType>(({ items }): JSX.Element => {
  return (
    <div class='page-builder-wrap'>
      {items.map((each, index) => (
        <PageItem key={index} item={each} />
      ))}
    </div>
  );
});
